import { cn } from '../lib/cn';

export interface AiAgentStarProps {
  className?: string;
}

/**
 * A compact pill marking a name as an AI agent. Internal only — it never reaches
 * a customer. Inline so it can sit right after any name, with or without an avatar.
 */
export function AiAgentStar({ className }: AiAgentStarProps) {
  return (
    <span
      role="img"
      aria-label="AI agent"
      title="AI agent"
      className={cn(
        'inline-flex shrink-0 items-center whitespace-nowrap rounded-full border border-border bg-bg-elevated px-1 py-0.5 align-middle text-caption font-medium leading-none text-text-primary',
        className,
      )}
    >
      AI
    </span>
  );
}
